var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgUserDefault = function SvgUserDefault(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "-179 268.3 60 60",
    style: {
      enableBackground: "new -179 268.3 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-131,311.2l-9.6-4.8c-0.9-0.5-1.5-1.4-1.5-2.4v-3.4c0.2-0.3,0.5-0.6,0.7-1c1.2-1.8,2.2-3.7,3-5.8c1.4-0.6,2.3-2,2.3-3.6v-4 c0-1-0.4-1.9-1-2.6v-5.3c0.1-0.5,0.3-3.8-2.1-6.5c-2.1-2.3-5.4-3.5-9.9-3.5s-7.9,1.2-9.9,3.5c-2.4,2.7-2.1,6-2.1,6.5v5.3 c-0.6,0.7-1,1.7-1,2.6v4c0,1.2,0.6,2.4,1.5,3.1c0.9,3.6,2.8,6.4,3.5,7.2v3.3c0,1-0.5,1.9-1.4,2.3l-8.9,4.9c-2.9,1.6-4.7,4.6-4.7,7.9 v3.2c0,4.7,15,6,23,6s23-1.3,23-6v-3C-126,315.8-127.9,312.7-131,311.2z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_default.f6c5282d.svg";
export { ForwardRef as ReactComponent };